import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";
import { findCompatibleYear, findCompatibleCategory } from "Utils";

import { Select, Switch, Tooltip } from "antd";
import { ICONS, SvgIcon, HideEye } from "../Common/Icons";
import DocumentsUploader from "../Common/DocumentUploader/DocumentsUploader";

import styles from "./BalanceSheet.local.scss";
const { Option } = Select;

class AddAnnexeSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: [],
      annexes: []
    };
  }

  handleDrop = acceptedFiles => {
    if (acceptedFiles.length === 0 || acceptedFiles.length >= 15) return;
    this.setState({
      attachments: acceptedFiles
    });
    this.prepareUploadedAnnexes(acceptedFiles);
  };

  prepareUploadedAnnexes = attachments => {
    const { accountingYears, annexeCategories, lng } = this.props;
    let annexes = attachments.map((attachment, index) => {
      return {
        id: index,
        fileName: attachment.name,
        year: findCompatibleYear(attachment.name, accountingYears),
        certified: 0,
        main: 0,
        hidden: 0,
        attachment: attachment,
        category: annexeCategories
          ? findCompatibleCategory(attachment.name, annexeCategories, lng)
          : null
      };
    });
    this.setState({
      annexes: annexes
    });
  };

  handleCategoryChange = (value, id) => {
    const { annexeCategories } = this.props;
    let { annexes } = this.state;
    let category = annexeCategories.filter(
      category => category.id === value
    )[0];

    let updatedAnnexes = annexes.map(annexe => {
      if (annexe.id === id) {
        return { ...annexe, category: category };
      }
      return annexe;
    });
    this.setState({
      annexes: updatedAnnexes
    });
  };

  handleYearChange = (value, id) => {
    let { annexes } = this.state;
    let updatedAnnexes = annexes.map(annexe => {
      if (annexe.id === id) {
        return { ...annexe, year: value };
      }
      return annexe;
    });
    this.setState({
      annexes: updatedAnnexes
    });
  };

  handleCertifiedChange = id => {
    let { annexes } = this.state;
    let updatedAnnexes = annexes.map(annexe => {
      if (annexe.id === id) {
        return { ...annexe, certified: !annexe.certified };
      }
      return annexe;
    });
    this.setState({
      annexes: updatedAnnexes
    });
  };

  handleMainChange = id => {
    let { annexes } = this.state;
    let updatedAnnexes = annexes.map(annexe => {
      if (annexe.id === id) {
        return { ...annexe, main: !annexe.main };
      }
      return annexe;
    });
    this.setState({
      annexes: updatedAnnexes
    });
  };

  handleHiddenChange = id => {
    let { annexes } = this.state;
    let updatedAnnexes = annexes.map(annexe => {
      if (annexe.id === id) {
        return { ...annexe, hidden: !annexe.hidden };
      }
      return annexe;
    });
    this.setState({
      annexes: updatedAnnexes
    });
  };

  handleDeleteAnnexe = item => {
    let { annexes, attachments } = this.state;
    let updatedAnnexes = annexes.filter(annexe => annexe.id !== item.id);
    let updatedAttachments = attachments.filter(
      attachment => attachment.name !== item.fileName
    );
    this.setState({
      annexes: updatedAnnexes,
      attachments: updatedAttachments
    });
  };

  renderEtatAnnexeFiduciary = item => {
    return (
      <div className={styles.etat_annexe_sidebar}>
        <div className={styles.etat_block}>
          <span>{_("certified")}</span>
          <Switch
            checked={item.certified}
            onChange={() => this.handleCertifiedChange(item.id)}
          />
        </div>
        <div className={styles.etat_block} style={{ width: "47%" }}>
          <span>{_("main")}</span>
          <Switch
            checked={item.main}
            onChange={() => this.handleMainChange(item.id)}
          />
        </div>
      </div>
    );
  };

  renderVisibilityClientAnnexeFiduciary = item => {
    return (
      <div className={styles.actions}>
        <div style={{ paddingLeft: "24px" }}>
          {item.hidden ? (
            <Tooltip placement="bottom" title={_("makeVisible")}>
              <span
                className={classnames(styles.action, styles.hidden_action)}
                onClick={() => this.handleHiddenChange(item.id)}
              >
                <HideEye className={classnames(styles.hidden)} />
              </span>
            </Tooltip>
          ) : (
            <Tooltip placement="bottom" title={_("Hide")}>
              <span
                className={classnames(styles.action, styles.visible_action)}
                onClick={() => this.handleHiddenChange(item.id)}
              >
                <SvgIcon
                  icon={ICONS.EyeIcon}
                  className={classnames(styles.visible)}
                />
              </span>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  renderDeleteActionFiduciary = item => {
    return (
      <div className={styles.actions}>
        <div style={{ paddingLeft: 0, width: "100%", paddingRight: 0 }}>
          <Tooltip placement="bottom" title={_("Delete")}>
            <span
              className={styles.action}
              onClick={() => this.handleDeleteAnnexe(item)}
            >
              <SvgIcon icon={ICONS.Garbage} className={styles.delete} />
            </span>
          </Tooltip>
        </div>
      </div>
    );
  };

  render() {
    const {
      saving,
      isAddingAnnexe,
      annexeCategories,
      accountingYears,
      lng
    } = this.props;

    const { attachments, annexes } = this.state;

    return (
      <div
        className={classnames(
          styles.sidebar,
          isAddingAnnexe ? styles.display : ""
        )}
        style={{ width: "950px" }}
      >
        <img
          src={"/img/icons/close.svg"}
          className={styles.sidebar__close}
          onClick={() => this.props.onCancelNewAnnexe()}
          alt={""}
        />

        <div className={styles.sidebar__titles}>
          <h4>{_("addAnnexes")}</h4>
          <h5>{_("importAnnexeSub")}</h5>
        </div>

        <div
          className={classnames(
            styles.labels_form_block,
            styles.labels_form_block_sidebar
          )}
        >
          <div className={styles.document_uploader}>
            <DocumentsUploader
              attachments={attachments}
              handleDrop={this.handleDrop}
              acceptedFiles=".pdf"
            />
          </div>
        </div>

        {annexes.length > 0 && (
          <div className={styles.annexe_states_block_sidebar}>
            <table className={styles.annexe_table}>
              <thead key={"thead"}>
                <tr>
                  <th width={200}>{_("fileName")}</th>
                  <th width={105}>{_("exercise")}</th>
                  <th width={170}>{_("category")}</th>
                  <th width={120}>{_("annexState")}</th>
                  <th width={80}>{_("visibility")}</th>
                </tr>
              </thead>

              <tbody key={"tbody"}>
                {annexes.map((item, i) => {
                  return (
                    <tr key={item.id}>
                      <td width={200}>
                        {item.fileName && item.fileName.length > 27 ? (
                          <Tooltip placement="top" title={item.fileName}>
                            <span>
                              {item.fileName && item.fileName.substring(0, 27)}
                              {"..."}
                            </span>
                          </Tooltip>
                        ) : (
                          item.fileName
                        )}
                      </td>
                      <td width={105}>
                        <Select
                          value={item.year}
                          onChange={value =>
                            this.handleYearChange(value, item.id)
                          }
                        >
                          {accountingYears &&
                            accountingYears.map((item, i) => {
                              return (
                                <Option value={item} key={i}>
                                  {item}
                                </Option>
                              );
                            })}
                        </Select>
                      </td>
                      <td width={200}>
                        <Select
                          value={item.category && item.category.label[lng]}
                          style={{ width: "250px" }}
                          onChange={value =>
                            this.handleCategoryChange(value, item.id)
                          }
                        >
                          {annexeCategories.length > 0 &&
                            annexeCategories.map((item, i) => {
                              return (
                                <Option value={item.id} key={i}>
                                  {item.label[lng]}
                                </Option>
                              );
                            })}
                        </Select>
                      </td>
                      <td width={120}>
                        {this.renderEtatAnnexeFiduciary(item)}
                      </td>
                      <td width={76}>
                        {this.renderVisibilityClientAnnexeFiduciary(item)}
                      </td>
                      <td width={36}>
                        {this.renderDeleteActionFiduciary(item)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        <div className={styles.actions_block}>
          <button
            className={styles.cancel_btn}
            onClick={() => this.props.onCancelNewAnnexe()}
          >
            {_("cancel")}
          </button>
          <button
            className={styles.save_button}
            disabled={!attachments || attachments.length === 0}
            onClick={() => this.props.handleSaveAnnexes(annexes)}
          >
            <img
              src={"/img/icons/tail-spin.svg"}
              alt={""}
              className={saving ? styles.loading : ""}
            />
            {_("save")}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lng: state.params.lng,
  organization: state.balance.organization,
  annexeCategories: state.annexeCategorySuggestions.enabled,
  accountingYears:
    (state.balanceSheet.balanceSheetData &&
      state.balanceSheet.balanceSheetData.years) ||
    []
});

export default connect(mapStateToProps)(AddAnnexeSideBar);



// WEBPACK FOOTER //
// ./src/components/BalanceSheet/AddAnnexeSideBar.js